import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import getCustomSIPHeaderOptions from 'API/CustomSIPHeaders/getCustomSIPHeaderOptions';

const useGetCustomSIPHeaderOptions = () => {
    const { currentScope } = useSelector((state) => state.login);

    return useQuery({
        queryKey: ['customSIPHeaderOptions', currentScope],
        queryFn: async () => {
            return getCustomSIPHeaderOptions(currentScope);
        },
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
};

export default useGetCustomSIPHeaderOptions;
